async function createReservation(API_BASE, token, data) {
    const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
    };

    const res = await fetch(`${API_BASE}/reservations`, {
        method: "POST",
        headers,
        body: JSON.stringify(data),
    });

    if (!res.ok) {
        throw new Error(await res.text());
    }

    return await res.json();
}
export default createReservation;
